import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';

/* PrimeNG Modules */
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { FileUploadModule } from 'primeng/fileupload';
import { MenubarModule } from 'primeng/menubar';
import { SidebarModule } from 'primeng/sidebar';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { CheckboxModule } from 'primeng/checkbox';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { BadgeModule } from 'primeng/badge';
import { AvatarModule } from 'primeng/avatar';
import { DividerModule } from 'primeng/divider';
import { TagModule } from 'primeng/tag';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ToolbarModule } from 'primeng/toolbar';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ProgressBarModule } from 'primeng/progressbar';
import { PaginatorModule } from 'primeng/paginator';

/* Angular CDK */
import { DragDropModule } from '@angular/cdk/drag-drop';

import { EmptyStateComponent } from './components/empty-state/empty-state.component';
import { ClubSelectComponent } from './components/club-select/club-select.component';
import { TransferStatusSelectComponent } from './components/transfer-status-select/transfer-status-select.component';
import { PlayerSelectComponent } from './components/player-select/player-select.component';
import { ClubLogoComponent } from './components/club-logo/club-logo.component';
import { AttachmentPickerComponent } from './components/attachment-picker/attachment-picker.component';
import { TransferSelectComponent } from './components/transfer-select/transfer-select.component';
import { EmailDetailComponent } from './components/email-detail/email-detail.component';
import { EmailSelectComponent } from './components/email-select/email-select.component';

@NgModule({
  declarations: [
    EmptyStateComponent,
    ClubSelectComponent,
    TransferStatusSelectComponent,
    PlayerSelectComponent,
    ClubLogoComponent,
    AttachmentPickerComponent,
    TransferSelectComponent,
    EmailDetailComponent,
    EmailSelectComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    
    // PrimeNG
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    AutoCompleteModule,
    TableModule,
    ToastModule,
    CardModule,
    DialogModule,
    FileUploadModule,
    MenubarModule,
    SidebarModule,
    CalendarModule,
    DropdownModule,
    InputNumberModule,
    CheckboxModule,
    TooltipModule,
    ConfirmDialogModule,
    BadgeModule,
    AvatarModule,
    DividerModule,
    TagModule,
    SelectButtonModule,
    ToolbarModule,
    InputSwitchModule,
    ProgressBarModule,
    PaginatorModule,
    DragDropModule
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
    EmptyStateComponent,
    ClubSelectComponent,
    TransferStatusSelectComponent,
    PlayerSelectComponent,
    ClubLogoComponent,
    AttachmentPickerComponent,
    TransferSelectComponent,
    EmailDetailComponent,
    EmailSelectComponent,

    // PrimeNG
    ButtonModule,
    InputTextModule,
    InputTextareaModule,
    AutoCompleteModule,
    TableModule,
    ToastModule,
    CardModule,
    DialogModule,
    FileUploadModule,
    MenubarModule,
    SidebarModule,
    CalendarModule,
    DropdownModule,
    InputNumberModule,
    CheckboxModule,
    TooltipModule,
    ConfirmDialogModule,
    BadgeModule,
    AvatarModule,
    DividerModule,
    TagModule,
    SelectButtonModule,
    ToolbarModule,
    InputSwitchModule,
    ProgressBarModule,
    PaginatorModule,
    DragDropModule
  ]
})
export class SharedModule { }
